/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrClaimSocialFollowRequest
 */
export interface RttrClaimSocialFollowRequest {
    /**
     * The objective being claimed. Its socialPolicy supplies the platform, so the platform is campaign configuration rather than a table in this file.
     * @type {string}
     * @memberof RttrClaimSocialFollowRequest
     */
    objectiveTemplateId?: string;
}

/**
 * Check if a given object implements the RttrClaimSocialFollowRequest interface.
 */
export function instanceOfRttrClaimSocialFollowRequest(value: object): value is RttrClaimSocialFollowRequest {
    return true;
}

export function RttrClaimSocialFollowRequestFromJSON(json: any): RttrClaimSocialFollowRequest {
    return RttrClaimSocialFollowRequestFromJSONTyped(json, false);
}

export function RttrClaimSocialFollowRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrClaimSocialFollowRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'objectiveTemplateId': json['objectiveTemplateId'] == null ? undefined : json['objectiveTemplateId'],
    };
}

export function RttrClaimSocialFollowRequestToJSON(json: any): RttrClaimSocialFollowRequest {
    return RttrClaimSocialFollowRequestToJSONTyped(json, false);
}

export function RttrClaimSocialFollowRequestToJSONTyped(value?: RttrClaimSocialFollowRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectiveTemplateId': value['objectiveTemplateId'],
    };
}

